
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// JobLens API Configuration for JSearch API
// In production (Vercel), use relative URLs so requests go to the same domain.
// In development, use localhost proxy server.
const $ba30e20475feac5a$var$isDev = typeof window !== 'undefined' && window.location.hostname === 'localhost';
const $ba30e20475feac5a$export$518c21aa5ffdf945 = $ba30e20475feac5a$var$isDev ? 'http://localhost:8080' : '';
const $ba30e20475feac5a$export$196440f71ed9f601 = 30;
const $ba30e20475feac5a$export$3f32c2013f0dcc1e = false;
const $ba30e20475feac5a$export$30dba1e0a1cb02c9 = {
    SEARCH: `${$ba30e20475feac5a$export$518c21aa5ffdf945}/api/jobs/search`,
    DETAILS: `${$ba30e20475feac5a$export$518c21aa5ffdf945}/api/jobs/details`,
    ANALYTICS: `${$ba30e20475feac5a$export$518c21aa5ffdf945}/api/jobs/analytics`,
    HEALTH: `${$ba30e20475feac5a$export$518c21aa5ffdf945}/api/health`
};
const $ba30e20475feac5a$export$4ef7fa4b63f29d9b = [
    'JavaScript',
    'TypeScript',
    'Python',
    'Java',
    'C#',
    'C++',
    'Go',
    'Rust',
    'Ruby',
    'PHP',
    'Swift',
    'Kotlin',
    'React',
    'Angular',
    'Vue',
    'Next.js',
    'Node.js',
    'Express',
    'Django',
    'Flask',
    'Spring',
    'AWS',
    'Azure',
    'GCP',
    'Docker',
    'Kubernetes',
    'Terraform',
    'SQL',
    'PostgreSQL',
    'MongoDB',
    'Redis',
    'MySQL',
    'GraphQL',
    'Git',
    'CI/CD',
    'Linux',
    'REST',
    'APIs',
    'HTML',
    'CSS',
    'SCSS',
    'Tailwind',
    'Machine Learning',
    'AI',
    'Data Science',
    'TensorFlow',
    'PyTorch',
    'Agile',
    'Scrum',
    'Jira'
];
const $ba30e20475feac5a$export$e3369203f6e47fa0 = {
    COUNTRY_CODES: {
        US: 'United States',
        GB: 'United Kingdom',
        DE: 'Germany',
        CA: 'Canada',
        AU: 'Australia',
        FR: 'France',
        NL: 'Netherlands',
        SG: 'Singapore',
        IN: 'India',
        JP: 'Japan'
    },
    JOB_TYPES: {
        REMOTE: true,
        ONSITE: false
    },
    DATE_POSTED: {
        today: 'today',
        three_day: '3days',
        week: 'week',
        month: 'month'
    },
    EXPERIENCE: {
        no_exp: 'no_experience',
        mid_exp: 'under_3_years_experience',
        high_exp: 'more_than_3_years_experience'
    }
};


// Exchange rate cache
let $bd02c871d9c5ba8e$var$exchangeRateCache = {};
let $bd02c871d9c5ba8e$var$cacheTimestamp = 0;
const $bd02c871d9c5ba8e$var$CACHE_DURATION = 3600000; // 1 hour
const $bd02c871d9c5ba8e$export$bef1f36f5486a6a3 = (0, $ba30e20475feac5a$export$3f32c2013f0dcc1e) ? console.log.bind(console) : ()=>{};
const $bd02c871d9c5ba8e$export$58da9968c3170cb1 = (0, $ba30e20475feac5a$export$3f32c2013f0dcc1e) ? console.error.bind(console) : ()=>{};
const $bd02c871d9c5ba8e$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
// In-memory GET request cache (URL -> {data, timestamp})
const $bd02c871d9c5ba8e$var$_requestCache = new Map();
const $bd02c871d9c5ba8e$var$REQUEST_CACHE_TTL = 300000; // 5 mins
const $bd02c871d9c5ba8e$export$d047a7c56db64af4 = async function(url, useCache = true) {
    try {
        // Return cached response if fresh
        if (useCache && $bd02c871d9c5ba8e$var$_requestCache.has(url)) {
            const cached = $bd02c871d9c5ba8e$var$_requestCache.get(url);
            if (Date.now() - cached.timestamp < $bd02c871d9c5ba8e$var$REQUEST_CACHE_TTL) {
                $bd02c871d9c5ba8e$export$bef1f36f5486a6a3("\uD83D\uDCE6 Cache hit:", url.split('?')[0]);
                return cached.data;
            }
            $bd02c871d9c5ba8e$var$_requestCache.delete(url);
        }
        $bd02c871d9c5ba8e$export$bef1f36f5486a6a3("\uD83D\uDCE1 Making request to:", url);
        const res = await Promise.race([
            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }),
            $bd02c871d9c5ba8e$var$timeout((0, $ba30e20475feac5a$export$196440f71ed9f601))
        ]);
        if (!res.ok) {
            const errorData = await res.json().catch(()=>({}));
            $bd02c871d9c5ba8e$export$58da9968c3170cb1(`\u{274C} HTTP Error ${res.status}:`, errorData);
            throw new Error(`${errorData.message || 'Request failed'} (${res.status})`);
        }
        const data = await res.json();
        // Cache successful responses
        if (useCache) $bd02c871d9c5ba8e$var$_requestCache.set(url, {
            data: data,
            timestamp: Date.now()
        });
        $bd02c871d9c5ba8e$export$bef1f36f5486a6a3("\u2705 Request successful:", url.split('?')[0]);
        return data;
    } catch (err) {
        $bd02c871d9c5ba8e$export$58da9968c3170cb1("\u274C Request failed:", err.message);
        throw err;
    }
};
// Utility function to convert currency with cached exchange rates
// Cache per-currency with individual timestamps for better cache management
const $bd02c871d9c5ba8e$var$_currencyCacheTimestamps = {};
const $bd02c871d9c5ba8e$export$dca80e37bfad9c5a = async function(amount, fromCurrency, toCurrency) {
    if (fromCurrency === toCurrency) return amount;
    if (!amount || isNaN(amount)) return amount;
    try {
        const now = Date.now();
        if (!$bd02c871d9c5ba8e$var$exchangeRateCache[fromCurrency] || now - ($bd02c871d9c5ba8e$var$_currencyCacheTimestamps[fromCurrency] || 0) > $bd02c871d9c5ba8e$var$CACHE_DURATION) {
            const res = await fetch(`https://api.exchangerate-api.com/v4/latest/${fromCurrency}`);
            const data = await res.json();
            $bd02c871d9c5ba8e$var$exchangeRateCache[fromCurrency] = data.rates;
            $bd02c871d9c5ba8e$var$_currencyCacheTimestamps[fromCurrency] = now;
        }
        const rate = $bd02c871d9c5ba8e$var$exchangeRateCache[fromCurrency]?.[toCurrency];
        if (!rate) throw new Error(`Conversion rate not found`);
        return amount * rate;
    } catch (err) {
        $bd02c871d9c5ba8e$export$58da9968c3170cb1("\u274C Currency conversion failed:", err.message);
        return amount; // fallback to original amount
    }
};
const $bd02c871d9c5ba8e$export$3dc27271f5d5c629 = async function(amount, currency = 'USD', convertTo = null) {
    if (!amount) return 'Not specified';
    let finalAmount = amount;
    if (convertTo && convertTo !== currency) finalAmount = await $bd02c871d9c5ba8e$export$dca80e37bfad9c5a(amount, currency, convertTo);
    const formatOptions = {
        style: 'currency',
        currency: convertTo || currency,
        maximumFractionDigits: 0
    };
    return new Intl.NumberFormat('en-US', formatOptions).format(finalAmount);
};
const $bd02c871d9c5ba8e$export$c551171ee60dbe12 = function(dateString) {
    if (!dateString) return 'Date not specified';
    const postedDate = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - postedDate);
    const diffDays = Math.floor(diffTime / 86400000);
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    return `${Math.floor(diffDays / 30)} months ago`;
};
const $bd02c871d9c5ba8e$export$247df46bedc80361 = function(companyName) {
    if (!companyName) return '?';
    return companyName.charAt(0).toUpperCase();
};
const $bd02c871d9c5ba8e$export$59a943b34a82e690 = function(text, maxLength = 150) {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
};
const $bd02c871d9c5ba8e$export$61fc7d43ac8f84b0 = function(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = ()=>{
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};



// Precompile skill regex patterns once at module load (avoids re-creation per call)
const $0f1d4402dffacf5b$var$SKILL_REGEX_MAP = (0, $ba30e20475feac5a$export$4ef7fa4b63f29d9b).map((skill)=>({
        name: skill,
        regex: new RegExp(`\\b${skill.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i')
    }));
// Use a Set for O(1) bookmark lookups instead of Array.some O(n)
let $0f1d4402dffacf5b$var$_bookmarkIdSet = new Set();
const $0f1d4402dffacf5b$export$ca000e230c0caa3e = {
    search: {
        query: '',
        results: [],
        page: 1,
        resultsPerPage: 10,
        totalJobs: 0,
        filters: {
            country: '',
            jobType: '',
            experience: '',
            sortBy: 'relevance'
        }
    },
    job: {},
    analytics: {
        query: '',
        loading: false,
        countries: [],
        totalJobs: 0,
        avgSalary: 0,
        countryCount: 0,
        remotePercent: 0,
        jobTypeDistribution: {
            remote: 0,
            hybrid: 0,
            onsite: 0
        },
        topSkills: [],
        demandByCountry: [],
        salaryByCountry: []
    },
    currency: {
        base: 'USD',
        target: '',
        rate: 1
    },
    bookmarks: []
};
// Convert JSearch job data to our app format
const $0f1d4402dffacf5b$var$formatJobData = function(jobData) {
    return jobData.map((job)=>({
            id: job.job_id,
            title: job.job_title,
            companyName: job.employer_name || 'Company not specified',
            location: `${job.job_city || ''}, ${job.job_country || ''}`.replace(/^, |, $/, ''),
            description: job.job_description || 'No description available',
            jobType: job.job_employment_types[0] || 'Not specified',
            salaryMin: job.job_min_salary || null,
            salaryMax: job.job_max_salary || null,
            salaryPeriod: job.job_salary_period || 'year',
            postedDate: job.job_posted_at_datetime_utc ? new Date(job.job_posted_at_datetime_utc).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
            applyUrl: job.job_apply_link || '',
            companyLogo: job.employer_logo || '',
            isRemote: job.job_is_remote || false,
            benefits: job.job_benefits || [],
            highlights: {
                qualifications: job.job_highlights?.Qualifications || [],
                responsibilities: job.job_highlights?.Responsibilities || []
            },
            isBookmarked: $0f1d4402dffacf5b$export$51484a9f0c0ed0a3(job.job_id)
        }));
};
// Build search parameters based on current state
const $0f1d4402dffacf5b$var$buildSearchParams = function(query, page = 1, filters = {}) {
    const params = new URLSearchParams({
        query: query || '',
        page: page.toString(),
        num_pages: '1'
    });
    // Add country filter
    if (filters.country && (0, $ba30e20475feac5a$export$e3369203f6e47fa0).COUNTRY_CODES[filters.country]) params.set('country', (0, $ba30e20475feac5a$export$e3369203f6e47fa0).COUNTRY_CODES[filters.country]);
    // Add employment type filter
    if (filters.jobType && (0, $ba30e20475feac5a$export$e3369203f6e47fa0).JOB_TYPES[filters.jobType.toUpperCase()]) params.set('work_from_home', (0, $ba30e20475feac5a$export$e3369203f6e47fa0).JOB_TYPES[filters.jobType.toUpperCase()]);
    if (filters.experience && (0, $ba30e20475feac5a$export$e3369203f6e47fa0).EXPERIENCE[filters.experience]) params.set('job_requirements', (0, $ba30e20475feac5a$export$e3369203f6e47fa0).EXPERIENCE[filters.experience]);
    // Add date filter based on sort
    if (filters.sortBy && (0, $ba30e20475feac5a$export$e3369203f6e47fa0).DATE_POSTED[filters.sortBy]) params.set('date_posted', (0, $ba30e20475feac5a$export$e3369203f6e47fa0).DATE_POSTED[filters.sortBy]);
    return params.toString();
};
const $0f1d4402dffacf5b$export$a9242d464ae29af9 = async function(query, page = 1, filters = {}) {
    try {
        (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\uD83D\uDD0D Searching for jobs:", {
            query: query,
            page: page,
            filters: filters
        });
        // Update state
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.query = query;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.page = page;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.filters = {
            ...$0f1d4402dffacf5b$export$ca000e230c0caa3e.search.filters,
            ...filters
        };
        // Build API URL with parameters
        const searchParams = $0f1d4402dffacf5b$var$buildSearchParams(query, page, filters);
        const apiUrl = `${(0, $ba30e20475feac5a$export$30dba1e0a1cb02c9).SEARCH}?${searchParams}`;
        (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\uD83D\uDCE1 API URL:", apiUrl);
        // Make API call (uses built-in request cache)
        const data = await (0, $bd02c871d9c5ba8e$export$d047a7c56db64af4)(apiUrl);
        // Process and format job data
        if (data.data && Array.isArray(data.data)) {
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results = $0f1d4402dffacf5b$var$formatJobData(data.data);
            $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.totalJobs = data.data.length;
            (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)(`\u{1F4C8} Total jobs found: ${$0f1d4402dffacf5b$export$ca000e230c0caa3e.search.totalJobs}`);
            if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.length === 0) {
                $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results = [];
                $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.totalJobs = 0;
                throw new Error("\u26A0\uFE0F No job data found in response");
            }
        }
        return $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results;
    } catch (err) {
        throw err;
    }
};
const $0f1d4402dffacf5b$export$c013c6fee509d498 = async function(jobId) {
    (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\uD83D\uDD0D Fetching job details for ID:", jobId);
    const apiUrl = `${(0, $ba30e20475feac5a$export$30dba1e0a1cb02c9).DETAILS}?job_id=${jobId}`;
    const data = await (0, $bd02c871d9c5ba8e$export$d047a7c56db64af4)(apiUrl);
    // Process job details
    if (data.data && data.data.length > 0) {
        const jobDetails = $0f1d4402dffacf5b$var$formatJobData(data.data)[0];
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.job = jobDetails;
        return jobDetails;
    }
    return null;
};
const $0f1d4402dffacf5b$export$381e6799299f1fad = function(currency) {
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.currency.target = currency;
};
const $0f1d4402dffacf5b$var$persistBookmarks = function() {
    localStorage.setItem('bookmarks', JSON.stringify($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks));
};
const $0f1d4402dffacf5b$export$72009cc673d27d80 = function(job) {
    job.isBookmarked = true;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.push(job);
    $0f1d4402dffacf5b$var$_bookmarkIdSet.add(job.id);
    // Update search results if job is there
    const searchJob = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.find((result)=>result.id === job.id);
    if (searchJob) searchJob.isBookmarked = true;
    $0f1d4402dffacf5b$var$persistBookmarks();
};
const $0f1d4402dffacf5b$export$2db69b245b3902c8 = function(jobId) {
    const bookmarkIndex = $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.findIndex((bookmark)=>bookmark.id === jobId);
    if (bookmarkIndex > -1) {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks[bookmarkIndex].isBookmarked = false;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.splice(bookmarkIndex, 1);
    }
    $0f1d4402dffacf5b$var$_bookmarkIdSet.delete(jobId);
    // Update search results if job is there
    const searchJob = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.find((result)=>result.id === jobId);
    if (searchJob) searchJob.isBookmarked = false;
    $0f1d4402dffacf5b$var$persistBookmarks();
};
const $0f1d4402dffacf5b$export$51484a9f0c0ed0a3 = function(jobId) {
    return $0f1d4402dffacf5b$var$_bookmarkIdSet.has(jobId);
};
// =============================================
// ANALYTICS FUNCTIONS
// =============================================
// Analytics cache to avoid re-fetching for the same query
let $0f1d4402dffacf5b$var$_analyticsCache = {
    query: '',
    data: null,
    timestamp: 0
};
const $0f1d4402dffacf5b$var$ANALYTICS_CACHE_TTL = 600000; // 10 minutes
const $0f1d4402dffacf5b$export$b0297573c90085aa = async function(query) {
    try {
        // Return cached analytics if query matches and cache is fresh
        if ($0f1d4402dffacf5b$var$_analyticsCache.query === query && $0f1d4402dffacf5b$var$_analyticsCache.data && Date.now() - $0f1d4402dffacf5b$var$_analyticsCache.timestamp < $0f1d4402dffacf5b$var$ANALYTICS_CACHE_TTL) {
            (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\uD83D\uDCE6 Analytics cache hit for:", query);
            return $0f1d4402dffacf5b$var$_analyticsCache.data;
        }
        (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\uD83D\uDCCA Fetching analytics for:", query);
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.loading = true;
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.query = query;
        const apiUrl = `${(0, $ba30e20475feac5a$export$30dba1e0a1cb02c9).ANALYTICS}?query=${encodeURIComponent(query)}`;
        const data = await (0, $bd02c871d9c5ba8e$export$d047a7c56db64af4)(apiUrl, false); // Don't double-cache analytics
        // Process the Adzuna analytics data
        $0f1d4402dffacf5b$var$processAnalyticsData(data);
        // Also extract skills from the already-fetched JSearch search results
        if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.length > 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.topSkills = $0f1d4402dffacf5b$var$extractTopSkills($0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results);
        // If JSearch skills are empty, extract from Adzuna descriptions
        if ($0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.topSkills.length === 0) {
            const adzunaDescriptions = (data.countries || []).flatMap((c)=>(c.descriptions || []).map((d)=>({
                        description: d.description || '',
                        highlights: {
                            Qualifications: [],
                            Responsibilities: []
                        }
                    })));
            if (adzunaDescriptions.length > 0) $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.topSkills = $0f1d4402dffacf5b$var$extractTopSkills(adzunaDescriptions);
        }
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.loading = false;
        // Cache the result
        $0f1d4402dffacf5b$var$_analyticsCache = {
            query: query,
            data: $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics,
            timestamp: Date.now()
        };
        return $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics;
    } catch (err) {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.loading = false;
        (0, $bd02c871d9c5ba8e$export$58da9968c3170cb1)("\u274C Analytics fetch failed:", err);
        throw err;
    }
};
// Process Adzuna analytics API response into usable state
const $0f1d4402dffacf5b$var$processAnalyticsData = function(data) {
    const countries = data.countries || [];
    // Total jobs (Adzuna returns real totals, can be thousands)
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.totalJobs = data.totalJobs || 0;
    // Countries with jobs
    const countriesWithJobs = countries.filter((c)=>c.jobCount > 0);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.countryCount = countriesWithJobs.length;
    // Average salary (USD) across all countries that have salary data
    const salariesUSD = countries.filter((c)=>c.avgSalaryUSD !== null && c.avgSalaryUSD > 0).map((c)=>c.avgSalaryUSD);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.avgSalary = salariesUSD.length > 0 ? Math.round(salariesUSD.reduce((a, b)=>a + b, 0) / salariesUSD.length) : 0;
    // Remote percentage (from sampled results)
    const totalSampled = countries.reduce((sum, c)=>sum + (c.totalResults || 0), 0);
    const totalRemote = countries.reduce((sum, c)=>sum + (c.remoteCount || 0), 0);
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.remotePercent = totalSampled > 0 ? Math.round(totalRemote / totalSampled * 100) : 0;
    // Job type distribution (estimated from sampled results)
    const remotePercent = $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.remotePercent;
    const nonRemote = 100 - remotePercent;
    // Industry average: ~30% of non-remote jobs are hybrid
    const hybridPercent = Math.round(nonRemote * 0.3);
    const onsitePercent = nonRemote - hybridPercent;
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.jobTypeDistribution = {
        remote: remotePercent,
        hybrid: hybridPercent,
        onsite: onsitePercent
    };
    // Demand by country (sorted by real total job count)
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.demandByCountry = countries.map((c)=>({
            code: c.code,
            name: c.name,
            flag: c.flag,
            count: c.jobCount || 0
        })).filter((c)=>c.count > 0).sort((a, b)=>b.count - a.count);
    // Salary by country (USD, sorted by salary)
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.salaryByCountry = countries.filter((c)=>c.avgSalaryUSD !== null && c.avgSalaryUSD > 0).map((c)=>({
            code: c.code,
            name: c.name,
            flag: c.flag,
            avgSalary: c.avgSalaryUSD,
            localCurrency: c.currency,
            localSalary: c.avgSalaryLocal
        })).sort((a, b)=>b.avgSalary - a.avgSalary);
    // Store processed countries data
    $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics.countries = countries;
    (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\uD83D\uDCCA Processed Adzuna analytics:", $0f1d4402dffacf5b$export$ca000e230c0caa3e.analytics);
};
// Extract top skills from job data using precompiled regex patterns
const $0f1d4402dffacf5b$var$extractTopSkills = function(jobs) {
    const skillCounts = {};
    jobs.forEach((job)=>{
        const text = [
            job.description || '',
            ...job.highlights?.qualifications || job.highlights?.Qualifications || [],
            ...job.highlights?.responsibilities || job.highlights?.Responsibilities || []
        ].join(' ').toLowerCase();
        // Use precompiled regex patterns for ~50x faster matching
        $0f1d4402dffacf5b$var$SKILL_REGEX_MAP.forEach(({ name: name, regex: regex })=>{
            if (regex.test(text)) skillCounts[name] = (skillCounts[name] || 0) + 1;
        });
    });
    const totalJobs = jobs.length || 1;
    return Object.entries(skillCounts).map(([name, count])=>({
            name: name,
            count: count,
            percent: Math.round(count / totalJobs * 100)
        })).sort((a, b)=>b.count - a.count).slice(0, 8);
};
const $0f1d4402dffacf5b$var$init = function() {
    try {
        const storageBookmarks = localStorage.getItem('bookmarks');
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks = storageBookmarks ? JSON.parse(storageBookmarks) : [];
        // Rebuild the Set for O(1) lookups
        $0f1d4402dffacf5b$var$_bookmarkIdSet = new Set($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.map((b)=>b.id));
    } catch (e) {
        $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks = [];
        $0f1d4402dffacf5b$var$_bookmarkIdSet = new Set();
    }
};
$0f1d4402dffacf5b$var$init();
const $0f1d4402dffacf5b$export$533f00fdb8b73d07 = async function() {
    const data = await (0, $bd02c871d9c5ba8e$export$d047a7c56db64af4)((0, $ba30e20475feac5a$export$30dba1e0a1cb02c9).HEALTH, false);
    (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\u2705 Server health:", data);
    return data;
};



var $1cd63cfe08530fad$exports = {};
$1cd63cfe08530fad$exports = import.meta.resolve("eyyUD");



class $a9762b486810d40b$var$BaseJobView {
    _data;
    async _formatSalaryDisplay(job, currency = 'USD', convertTo = null) {
        if (job.salaryMin && job.salaryMax) return `${await (0, $bd02c871d9c5ba8e$export$3dc27271f5d5c629)(job.salaryMin, currency, convertTo)} - ${await (0, $bd02c871d9c5ba8e$export$3dc27271f5d5c629)(job.salaryMax, currency, convertTo)}`;
        else if (job.salaryMin) return `${await (0, $bd02c871d9c5ba8e$export$3dc27271f5d5c629)(job.salaryMin, currency, convertTo)}+`;
        else if (job.salaryMax) return `Up to ${await (0, $bd02c871d9c5ba8e$export$3dc27271f5d5c629)(job.salaryMax, currency, convertTo)}`;
        return 'Salary not specified';
    }
    _getJobTypeTag(jobType) {
        const typeMap = {
            FULLTIME: 'Full-time',
            PARTTIME: 'Part-time',
            CONTRACTOR: 'Contract',
            INTERN: 'Internship'
        };
        const displayType = typeMap[jobType] || jobType || 'Full-time';
        const cssClass = jobType?.toLowerCase() || 'fulltime';
        return `<span class="job-card__tag job-card__tag--${cssClass}">${displayType}</span>`;
    }
    _getCompanyInitial(companyName) {
        return (0, $bd02c871d9c5ba8e$export$247df46bedc80361)(companyName);
    }
    _formatPostedDate(postedDate) {
        return (0, $bd02c871d9c5ba8e$export$c551171ee60dbe12)(postedDate);
    }
    _truncateText(text, length) {
        return (0, $bd02c871d9c5ba8e$export$59a943b34a82e690)(text, length);
    }
}
var $a9762b486810d40b$export$2e2bcd8739ae039 = $a9762b486810d40b$var$BaseJobView;



class $67c1b3a106a8708b$var$JobsResultView extends (0, $a9762b486810d40b$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector('.results');
    _emptyEl = this._parentEl?.querySelector('[data-results-empty]');
    _loadingEl = this._parentEl?.querySelector('[data-results-loading]');
    _errorEl = this._parentEl?.querySelector('[data-results-error]');
    _resultsGridEl = this._parentEl?.querySelector('[data-results-container]');
    _resultsCountEl = this._parentEl?.querySelector('[data-results-count] strong');
    _data;
    _currencyVal;
    constructor(){
        super();
    }
    async render(data, currency) {
        if (!currency) this._data = data;
        else {
            this._data = data;
            this._currencyVal = currency;
        }
        this._hideAllStates();
        // Update results count
        if (this._resultsCountEl) this._resultsCountEl.textContent = data.totalJobs || data.results?.length || 0;
        if (!data.results || data.results.length === 0) {
            this._showEmptyState();
            return;
        }
        // Generate and insert markup
        const markup = await this._generateMarkup();
        if (this._resultsGridEl) this._resultsGridEl.innerHTML = markup;
    }
    clearGrid() {
        this._resultsGridEl.innerHTML = '';
    }
    renderSpinner() {
        this._hideAllStates();
        this._loadingEl?.classList.remove('hidden');
    }
    renderError(message = 'Something went wrong. Please try again.') {
        this._hideAllStates();
        this._errorEl?.classList.remove('hidden');
        const errorMessageEl = this._errorEl?.querySelector('[data-error-message]');
        if (errorMessageEl) errorMessageEl.textContent = message;
    }
    _hideAllStates() {
        this._emptyEl?.classList.add('hidden');
        this._loadingEl?.classList.add('hidden');
        this._errorEl?.classList.add('hidden');
    }
    _showEmptyState() {
        this._emptyEl?.classList.remove('hidden');
        if (this._resultsGridEl) this._resultsGridEl.innerHTML = '';
    }
    async _generateMarkup() {
        const cards = await Promise.all(this._data.results.map((job)=>this._generateJobCard(job)));
        return cards.join('');
    }
    async _generateJobCard(job) {
        const companyInitial = this._getCompanyInitial(job.companyName);
        const description = this._truncateText(job.description, 120);
        const salaryDisplay = await this._formatSalaryDisplay(job, this._currencyVal?.base, this._currencyVal?.target);
        const postedDate = this._formatPostedDate(job.postedDate);
        const jobTypeTag = this._getJobTypeTag(job.jobType);
        const remoteTag = job.isRemote ? '<span class="job-card__tag job-card__tag--remote">Remote</span>' : '';
        return `
      <article class="job-card" data-job-id="${job.id}">
        <div class="job-card__header">
          <div class="job-card__company-logo" data-company-logo>
            ${job.companyLogo ? `<img src="${job.companyLogo}" alt="${job.companyName}" loading="lazy" decoding="async" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
               <span style="display:none;">${companyInitial}</span>` : `<span>${companyInitial}</span>`}
          </div>
          <div class="job-card__meta">
            <span class="job-card__company">${job.companyName}</span>
            <span class="job-card__location">
              <svg>
                <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-location"></use>
              </svg>
              ${job.location}
            </span>
          </div>
          <button
            class="job-card__bookmark ${job.isBookmarked ? 'job-card__bookmark--active' : ''}"
            data-bookmark-btn
            aria-label="Bookmark job"
          >
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-bookmark"></use>
            </svg>
          </button>
        </div>

        <div class="job-card__body">
          <h3 class="job-card__title">${job.title}</h3>
          <p class="job-card__description">
            ${description}
          </p>

          <div class="job-card__tags">
            ${remoteTag}
            ${jobTypeTag}
          </div>
        </div>

        <div class="job-card__footer">
          <div class="job-card__salary">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-dollar"></use>
            </svg>
            <span class="job-card__salary-amount" data-salary>
              ${salaryDisplay}
            </span>
          </div>
          <span class="job-card__posted">${postedDate}</span>
        </div>
      </article>
    `;
    }
    addHandlerRetry(handler) {
        const retryBtn = this._errorEl?.querySelector('[data-retry-btn]');
        retryBtn?.addEventListener('click', ()=>{
            if (this._data && this._data.query) handler(this._data.query, this._data.page || 1, this._data.filters || {});
        });
    }
    addHandlerBookmark(handler) {
        this._resultsGridEl?.addEventListener('click', (e)=>{
            e.preventDefault();
            const bookmarkBtn = e.target.closest('[data-bookmark-btn]');
            if (bookmarkBtn) {
                bookmarkBtn.classList.toggle('job-card__bookmark--active');
                const jobCard = bookmarkBtn.closest('[data-job-id]');
                const jobId = jobCard?.dataset.jobId;
                if (jobId) handler(jobId);
            }
        });
    }
    addHandlerJobClick(handler) {
        this._resultsGridEl?.addEventListener('click', function(e) {
            const bookmarkBtn = e.target.closest('[data-bookmark-btn]');
            if (bookmarkBtn) return;
            const jobEl = e.target.closest('.job-card');
            if (!jobEl) return;
            const jobID = jobEl.dataset.jobId;
            handler(jobID);
        });
    }
}
var $67c1b3a106a8708b$export$2e2bcd8739ae039 = new $67c1b3a106a8708b$var$JobsResultView();


class $4a4a6495d2c823bb$var$JobSearchView {
    _parentEL = document.querySelector('.search');
    constructor(){
        this._searchInput = this._parentEL?.querySelector('[data-search-input]');
        this._searchBtn = this._parentEL?.querySelector('[data-search-btn]');
        this._countryFilter = this._parentEL?.querySelector('[data-filter-country]');
        this._typeFilter = this._parentEL?.querySelector('[data-filter-type]');
        this._experienceFilter = this._parentEL?.querySelector('[data-filter-experience]');
        this._sortFilter = this._parentEL?.querySelector('[data-filter-sort]');
        this._clearBtn = this._parentEL?.querySelector('[data-search-clear]');
        this._suggestions = this._parentEL?.querySelector('[data-search-suggestions]');
    }
    getSearchQuery() {
        return this._searchInput?.value.trim() || '';
    }
    clearSearch() {
        if (this._searchInput) {
            this._searchInput.value = '';
            this._clearBtn?.classList.add('hidden');
        }
    }
    getFilters() {
        return {
            country: this._countryFilter?.value || '',
            jobType: this._typeFilter?.value || '',
            experience: this._experienceFilter?.value || '',
            sortBy: this._sortFilter?.value || ''
        };
    }
    showClearButton() {
        this._clearBtn?.classList.remove('hidden');
    }
    hideClearButton() {
        this._clearBtn?.classList.add('hidden');
    }
    addHandlerSearch(handler) {
        const executeSearch = ()=>{
            const query = this.getSearchQuery();
            if (!query) return;
            const filters = this.getFilters();
            this.showClearButton();
            handler(query, 1, filters);
        };
        // Handle Enter key in search input
        this._searchInput?.addEventListener('keypress', (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                executeSearch();
            }
        });
        // Handle search button click
        this._searchBtn?.addEventListener('click', (e)=>{
            e.preventDefault();
            executeSearch();
        });
        // Handle clear button
        this._clearBtn?.addEventListener('click', (e)=>{
            e.preventDefault();
            this.clearSearch();
            this.hideClearButton();
        });
        // Show/hide clear button based on input content
        this._searchInput?.addEventListener('input', (e)=>{
            if (e.target.value.trim()) this.showClearButton();
            else this.hideClearButton();
        });
    }
    addHandlerFilters(handler) {
        const filterElements = [
            this._countryFilter,
            this._typeFilter,
            this._experienceFilter,
            this._sortFilter
        ].filter(Boolean);
        filterElements.forEach((filter)=>{
            filter.addEventListener('change', ()=>{
                const query = this.getSearchQuery();
                if (!query) return;
                const filters = this.getFilters();
                handler(filters);
            });
        });
    }
    addHandlerSuggestions(handler) {
        const suggestionTags = this._parentEL?.querySelectorAll('[data-suggestion]');
        suggestionTags?.forEach((tag)=>{
            tag.addEventListener('click', (e)=>{
                const suggestion = e.target.dataset.suggestion;
                if (suggestion && this._searchInput) {
                    this._searchInput.value = suggestion;
                    this.showClearButton();
                    const filters = this.getFilters();
                    handler(suggestion, 1, filters);
                }
            });
        });
    }
    showSuggestions() {
        this._suggestions?.classList.remove('hidden');
    }
    hideSuggestions() {
        this._suggestions?.classList.add('hidden');
    }
    focusSearch() {
        this._searchInput?.focus();
    }
}
var $4a4a6495d2c823bb$export$2e2bcd8739ae039 = new $4a4a6495d2c823bb$var$JobSearchView();



class $cfa940594ee109f7$var$PaginationView {
    _parentEl = document.querySelector('[data-pagination]');
    _currentPage = 1;
    _maxVisiblePages = 5;
    render(data) {
        this._currentPage = data.page || 1;
        // Only show pagination if we have results
        if (!data.results || data.results.length === 0) {
            this._hide();
            return;
        }
        const markup = this._generateMarkup(data);
        this._parentEl.innerHTML = markup;
        this._show();
    }
    _generateMarkup(data) {
        const currentPage = data.page || 1;
        const hasMoreResults = data.results && data.results.length >= (data.resultsPerPage || 10);
        let html = `
      <div class="pagination">
        <!-- Previous Button -->
        <button 
          class="pagination__btn pagination__btn--prev" 
          data-pagination-prev
          ${currentPage === 1 ? 'disabled' : ''}
        >
          <svg>
            <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports)))}#icon-arrow-left"></use>
          </svg>
          Previous
        </button>

        <!-- Page Info -->
        <div class="pagination__info">
          <span>Page <strong>${currentPage}</strong></span>
        </div>

        <!-- Next Button -->
        <button 
          class="pagination__btn pagination__btn--next" 
          data-pagination-next
          ${!hasMoreResults ? 'disabled' : ''}
          title="${!hasMoreResults ? 'No more results available' : ''}"
        >
          Next
          <svg>
            <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports)))}#icon-arrow-right"></use>
          </svg>
        </button>
      </div>
    `;
        return html;
    }
    addHandlerClick(handler) {
        this._parentEl?.addEventListener('click', (e)=>{
            const prevBtn = e.target.closest('[data-pagination-prev]');
            const nextBtn = e.target.closest('[data-pagination-next]');
            if (prevBtn && !prevBtn.disabled) handler(this._currentPage - 1);
            if (nextBtn && !nextBtn.disabled) handler(this._currentPage + 1);
        });
    }
    _show() {
        this._parentEl?.classList.remove('hidden');
    }
    _hide() {
        this._parentEl?.classList.add('hidden');
    }
}
var $cfa940594ee109f7$export$2e2bcd8739ae039 = new $cfa940594ee109f7$var$PaginationView();




class $a2f79806c4e7b655$var$JobModalView extends (0, $a9762b486810d40b$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector('.job-modal');
    _jobModal = this._parentEl?.querySelector('.job-modal__content');
    _data;
    constructor(){
        super();
        this.addHandlerCloseModal();
    }
    _addModalView() {
        this._parentEl.classList.remove('hidden');
    }
    _hideModalView() {
        this._parentEl.classList.add('hidden');
    }
    async render(data) {
        this._jobModal.innerHTML = '';
        this._data = data;
        const markup = await this._generateMarkup();
        this._jobModal.insertAdjacentHTML('beforeend', markup);
        this._addModalView();
    }
    async _generateMarkup() {
        const companyInitial = this._getCompanyInitial(this._data.companyName);
        const description = this._truncateText(this._data.description, 500);
        const postedDate = this._formatPostedDate(this._data.postedDate);
        const jobTypeTag = this._getJobTypeTag(this._data.jobType);
        const responsibilitiesList = this._getListItems(this._data.highlights.responsibilities);
        const qualificationsList = this._getListItems(this._data.highlights.qualifications);
        const remoteTag = this._data.isRemote ? '<span class="job-card__tag job-card__tag--remote">Remote</span>' : '';
        return `
        <button
              class="job-modal__close"
              data-modal-close
              aria-label="Close modal"
            >
              <svg><use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-close"></use></svg>
            </button>

            <div class="job-modal__header">
              <div class="job-modal__company">
                <div class="job-modal__company-logo" data-modal-logo>
                   ${this._data.companyLogo ? `<img src="${this._data.companyLogo}" alt="${this._data.companyName}" loading="lazy" decoding="async" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
               <span style="display:none;">${companyInitial}</span>` : `<span>${companyInitial}</span>`}
                </div>
                <div class="job-modal__company-info">
                  <h2 class="job-modal__title" data-modal-title>
                    ${this._data.title}
                  </h2>
                  <p class="job-modal__company-name" data-modal-company>
                    ${this._data.companyName}
                  </p>
                </div>
              </div>
              <button
                class="job-modal__bookmark ${this._data.isBookmarked ? 'job-modal__bookmark--active' : ''}"
                data-modal-bookmark
                aria-label="Bookmark job"
              >
                <svg><use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-bookmark"></use></svg>
                <span>${this._data.isBookmarked ? 'Saved' : 'Save Job'}</span>
              </button>
            </div>

            <div class="job-modal__meta">
              <div class="job-modal__meta-item">
                <svg><use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-location"></use></svg>
                <span data-modal-location>${this._data.location}</span>
              </div>
              <div class="job-modal__meta-item">
                <svg><use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-dollar"></use></svg>
                <span data-modal-salary>${await this._formatSalaryDisplay(this._data, 'USD')}</span>
              </div>
              <div class="job-modal__meta-item">
                <svg><use href="./src/img/icons.svg#icon-calendar"></use></svg>
                <span data-modal-posted>Posted ${postedDate}</span>
              </div>
            </div>

            <div class="job-modal__tags" data-modal-tags>
              ${remoteTag}
              ${jobTypeTag}
            </div>

            <div class="job-modal__section">
              <h3 class="job-modal__section-title">Job Description</h3>
              <div class="job-modal__description" data-modal-description>
                <p>
                  ${description}
                </p>

                <h4>Responsibilities:</h4>
                ${responsibilitiesList}

                <h4>Requirements:</h4>
                ${qualificationsList}
              </div>
            </div>

            <div class="job-modal__section">
              <h3 class="job-modal__section-title">Salary Comparison</h3>
              <div
                class="job-modal__salary-comparison"
                data-modal-salary-comparison
              >
                <div class="salary-comparison__item">
                  <span class="salary-comparison__currency">USD</span>
                  <span class="salary-comparison__value">${await this._formatSalaryDisplay(this._data, 'USD')}</span>
                </div>
                <div class="salary-comparison__item">
                  <span class="salary-comparison__currency">EUR</span>
                  <span class="salary-comparison__value"
                    >${await this._formatSalaryDisplay(this._data, 'USD', 'EUR')}</span
                  >
                </div>
                <div class="salary-comparison__item">
                  <span class="salary-comparison__currency">GBP</span>
                  <span class="salary-comparison__value"
                    >${await this._formatSalaryDisplay(this._data, 'USD', 'GBP')}</span
                  >
                </div>
                <div
                  class="salary-comparison__item salary-comparison__item--highlight"
                >
                  <span class="salary-comparison__currency">NPR</span>
                  <span class="salary-comparison__value"
                    >${await this._formatSalaryDisplay(this._data, 'USD', 'NPR')}</span
                  >
                </div>
              </div>
            </div>  

            <div class="job-modal__actions">
              <a
                href="${this._data.applyUrl}"
                class="job-modal__apply-btn"
                data-modal-apply
                target="_blank"
                rel="noopener noreferrer"
              >
                Apply Now
                <svg>
                  <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-external-link"></use>
                </svg>
              </a>
              
            </div>`;
    }
    _getListItems(list) {
        return `
                <ul>
                ${list.map((item)=>`
                    <li>${item}</li>
                    `).join('')}
                </ul>`;
    }
    addHandlerCloseModal() {
        this._parentEl.addEventListener('click', (e)=>{
            const btn = e.target.closest('.job-modal__close');
            if (!btn) return;
            this._hideModalView();
        });
    }
    addHandlerBookmarkModal(handler) {
        this._parentEl.addEventListener('click', (e)=>{
            const btn = e.target.closest('.job-modal__bookmark');
            if (!btn) return;
            handler(this._data);
            // Update button state
            btn.classList.toggle('job-modal__bookmark--active');
            const span = btn.querySelector('span');
            if (span) span.textContent = btn.classList.contains('job-modal__bookmark--active') ? 'Saved' : 'Save Job';
        });
    }
}
var $a2f79806c4e7b655$export$2e2bcd8739ae039 = new $a2f79806c4e7b655$var$JobModalView();


class $5c69f0cf8a0ecb5c$var$HeaderView {
    _parentEl = document.querySelector('.header');
    _navBtns = document.querySelectorAll('.header__nav-btn');
    _sections = document.querySelectorAll('section');
    _currenySelector = this._parentEl.querySelector('.currency-selector__select');
    addHandlerCurrency(handler) {
        this._currenySelector.addEventListener('change', function(e) {
            handler(e.target.value);
        });
    }
    addHandlerNavBtn() {
        this._navBtns.forEach((btn)=>btn.addEventListener('click', ()=>{
                this._resetNavBtns();
                this._resetSections();
                btn.classList.add('header__nav-btn--active');
                const query = btn.dataset.view;
                const section = document.querySelector(`[data-view-container="${query}"]`);
                section.classList.remove('hidden');
            }));
    }
    _resetNavBtns() {
        this._navBtns.forEach((btn)=>btn.classList.remove('header__nav-btn--active'));
    }
    _resetSections() {
        this._sections.forEach((section)=>section.classList.add('hidden'));
    }
}
var $5c69f0cf8a0ecb5c$export$2e2bcd8739ae039 = new $5c69f0cf8a0ecb5c$var$HeaderView();




class $5d1bb7e064b2cbd1$var$BookmarksView extends (0, $a9762b486810d40b$export$2e2bcd8739ae039) {
    _parentEl = document.querySelector('.bookmarks');
    _bookmarksList = this._parentEl?.querySelector('[data-bookmarks-list]');
    _headerBookmarkCount = document.querySelector('[data-bookmark-count]');
    _bookmarksEmpty = this._parentEl?.querySelector('[data-bookmarks-empty]');
    _data;
    async render(data, currency) {
        if (!currency) this._data = data;
        else {
            this._data = data;
            this._currencyVal = currency;
        }
        if (this._data.length === 0) {
            this._bookmarksEmpty.classList.remove('hidden');
            this._headerBookmarkCount.textContent = this._data.length;
            this._bookmarksList.innerHTML = '';
        } else {
            this._bookmarksEmpty.classList.add('hidden');
            this._bookmarksList.innerHTML = '';
            this._headerBookmarkCount.textContent = this._data.length;
            const markup = await this._generateMarkup();
            this._bookmarksList.insertAdjacentHTML('beforeend', markup);
        }
    }
    async _generateMarkup() {
        const markupPromises = this._data.map(async (job)=>{
            const companyInitial = this._getCompanyInitial(job.companyName);
            const salaryDisplay = await this._formatSalaryDisplay(job, this._currencyVal?.base, this._currencyVal?.target);
            return `
                <article class="bookmark-item" data-bookmark-id="${job.id}">
                  <div class="bookmark-item__main">
                    <div class="bookmark-item__icon">
                       ${job.companyLogo ? `<img src="${job.companyLogo}" alt="${job.companyName}" loading="lazy" decoding="async" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
               <span style="display:none;">${companyInitial}</span>` : `<span>${companyInitial}</span>`}
                    </div>
                    <div class="bookmark-item__info">
                      <h4 class="bookmark-item__title">${job.title}</h4>
                      <p class="bookmark-item__meta">
                        <span>Amazon</span>
                        <span class="bookmark-item__separator">\u{2022}</span>
                        <span>${job.location}</span>
                      </p>
                      <div class="bookmark-item__tags">
                        <span class="bookmark-item__tag">${job.isRemote ? 'Remote' : 'On-site'}</span>
                        <span class="bookmark-item__tag">${salaryDisplay}</span>
                      </div>
                    </div>
                  </div>
                  <div class="bookmark-item__actions">
                    <button
                      class="bookmark-item__btn"
                      data-view-job
                      aria-label="View job details"
                    >
                      <svg><use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-eye"></use></svg>
                    </button>
                    <button
                      class="bookmark-item__btn bookmark-item__btn--remove"
                      data-remove-bookmark
                      aria-label="Remove bookmark"
                    >
                      <svg>
                        <use href="${0, (/*@__PURE__*/$parcel$interopDefault($1cd63cfe08530fad$exports))}#icon-trash"></use>
                      </svg>
                    </button>
                  </div>
                </article>`;
        });
        const markups = await Promise.all(markupPromises);
        return markups.join('');
    }
    addHandlerRemoveBookmark(handler) {
        this._parentEl.addEventListener('click', function(e) {
            const btn = e.target.closest('.bookmark-item__btn--remove');
            if (!btn) return;
            const bookmarkItem = e.target.closest('.bookmark-item');
            const bookmarkId = bookmarkItem.dataset.bookmarkId;
            handler(bookmarkId);
        });
    }
    addHandlerViewBookmark(handler) {
        this._parentEl.addEventListener('click', function(e) {
            const btn = e.target.closest('[data-view-job]');
            if (!btn) return;
            const bookmarkItem = e.target.closest('.bookmark-item');
            const bookmarkId = bookmarkItem.dataset.bookmarkId;
            handler(bookmarkId, 'bookmark');
        });
    }
}
var $5d1bb7e064b2cbd1$export$2e2bcd8739ae039 = new $5d1bb7e064b2cbd1$var$BookmarksView();



class $63032305c62fef5e$var$AnalyticsView {
    _parentEl = document.querySelector('.analytics-view');
    _analyticsEl = this._parentEl?.querySelector('[data-analytics-content]');
    _emptyEl = this._parentEl?.querySelector('[data-analytics-empty]');
    // Stat elements
    _roleEl = this._parentEl?.querySelector('[data-analytics-role]');
    _statJobsEl = this._parentEl?.querySelector('[data-stat-jobs]');
    _statSalaryEl = this._parentEl?.querySelector('[data-stat-salary]');
    _statCountriesEl = this._parentEl?.querySelector('[data-stat-countries]');
    _statRemoteEl = this._parentEl?.querySelector('[data-stat-remote]');
    // Chart containers
    _demandChartEl = this._parentEl?.querySelector('[data-chart="demand"]');
    _salaryChartEl = this._parentEl?.querySelector('[data-chart="salary"]');
    _typeChartEl = this._parentEl?.querySelector('[data-chart="type"]');
    _skillsChartEl = this._parentEl?.querySelector('[data-chart="skills"]');
    // Currency display
    _salaryCurrencyEl = this._parentEl?.querySelector('[data-salary-currency]');
    // Salary converter elements
    _salaryInputEl = this._parentEl?.querySelector('[data-salary-input]');
    _fromCurrencyEl = this._parentEl?.querySelector('[data-from-currency]');
    _toCurrencyEl = this._parentEl?.querySelector('[data-to-currency]');
    _convertedSalaryEl = this._parentEl?.querySelector('[data-converted-salary]');
    _resultCurrencyEl = this._parentEl?.querySelector('[data-result-currency]');
    _data = null;
    // Format large numbers (e.g., 12500 -> "12.5K", 1200000 -> "1.2M")
    _formatNumber(num) {
        if (!num) return '0';
        if (num >= 1000000) return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
        if (num >= 1000) return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}K`;
        return num.toLocaleString();
    }
    // Show empty state (before any search)
    renderEmpty() {
        if (!this._parentEl) return;
        if (this._emptyEl) this._emptyEl.style.display = '';
        if (this._analyticsEl) this._analyticsEl.style.display = 'none';
    }
    // Hide empty state and show content
    _showContent() {
        if (this._emptyEl) this._emptyEl.style.display = 'none';
        if (this._analyticsEl) this._analyticsEl.style.display = '';
    }
    // Render analytics data into the view
    render(analyticsData) {
        if (!analyticsData || !this._parentEl) return;
        this._data = analyticsData;
        this._showContent();
        (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\uD83C\uDFA8 Rendering analytics view:", analyticsData);
        // Update role title
        if (this._roleEl) this._roleEl.textContent = analyticsData.query || 'N/A';
        // Render stats summary
        this._renderStats(analyticsData);
        // Render charts
        this._renderDemandChart(analyticsData.demandByCountry);
        this._renderSalaryChart(analyticsData.salaryByCountry);
        this._renderTypeChart(analyticsData.jobTypeDistribution, analyticsData.totalJobs);
        this._renderSkillsChart(analyticsData.topSkills);
    }
    // Show loading state
    renderSpinner() {
        if (!this._parentEl) return;
        this._showContent();
        // Add loading class to stat values
        const statValues = this._parentEl.querySelectorAll('.stat-card__value');
        statValues.forEach((el)=>{
            el.textContent = '...';
            el.classList.add('loading');
        });
        // Show loading in charts
        [
            this._demandChartEl,
            this._salaryChartEl,
            this._typeChartEl,
            this._skillsChartEl
        ].forEach((el)=>{
            if (el) el.innerHTML = '<div class="chart-loading"><div class="spinner"><div class="spinner__ring"></div></div><p>Loading analytics...</p></div>';
        });
    }
    // Remove loading state
    _clearLoading() {
        const statValues = this._parentEl?.querySelectorAll('.stat-card__value');
        statValues?.forEach((el)=>el.classList.remove('loading'));
    }
    // Show error state
    renderError(message = 'Failed to load analytics data.') {
        this._clearLoading();
        [
            this._demandChartEl,
            this._salaryChartEl,
            this._typeChartEl,
            this._skillsChartEl
        ].forEach((el)=>{
            if (el) el.innerHTML = `<div class="chart-error"><p>${message}</p></div>`;
        });
    }
    // =============================================
    // Stats Summary
    // =============================================
    _renderStats(data) {
        this._clearLoading();
        if (this._statJobsEl) this._statJobsEl.textContent = this._formatNumber(data.totalJobs);
        if (this._statSalaryEl) this._statSalaryEl.textContent = data.avgSalary ? `$${data.avgSalary.toLocaleString()}` : 'N/A';
        if (this._statCountriesEl) this._statCountriesEl.textContent = data.countryCount || '0';
        if (this._statRemoteEl) this._statRemoteEl.textContent = data.remotePercent ? `${data.remotePercent}%` : '0%';
        // Hide trend indicators (we don't have historical data)
        const trends = this._parentEl?.querySelectorAll('.stat-card__trend');
        trends?.forEach((el)=>el.style.display = 'none');
    }
    // =============================================
    // Demand by Country Chart
    // =============================================
    _renderDemandChart(demandData) {
        if (!this._demandChartEl || !demandData || demandData.length === 0) {
            if (this._demandChartEl) this._demandChartEl.innerHTML = '<div class="chart-empty">No demand data available</div>';
            return;
        }
        const maxCount = Math.max(...demandData.map((d)=>d.count));
        const barsMarkup = demandData.map((country)=>{
            const widthPercent = maxCount > 0 ? Math.round(country.count / maxCount * 100) : 0;
            const formattedCount = this._formatNumber(country.count);
            return `
          <div class="demand-bar">
            <div class="demand-bar__label">
              <span class="demand-bar__flag">${country.flag}</span>
              <span class="demand-bar__country">${country.name}</span>
            </div>
            <div class="demand-bar__track">
              <div class="demand-bar__fill" style="--width: ${widthPercent}%"></div>
            </div>
            <span class="demand-bar__value">${formattedCount}</span>
          </div>
        `;
        }).join('');
        this._demandChartEl.innerHTML = `<div class="demand-bars">${barsMarkup}</div>`;
        // Animate bars
        requestAnimationFrame(()=>{
            this._demandChartEl.querySelectorAll('.demand-bar__fill').forEach((bar)=>{
                bar.style.width = bar.style.getPropertyValue('--width');
            });
        });
    }
    // =============================================
    // Salary by Country Chart
    // =============================================
    _renderSalaryChart(salaryData) {
        if (!this._salaryChartEl || !salaryData || salaryData.length === 0) {
            if (this._salaryChartEl) this._salaryChartEl.innerHTML = '<div class="chart-empty">No salary data available</div>';
            return;
        }
        const maxSalary = Math.max(...salaryData.map((d)=>d.avgSalary));
        // Short country names
        const shortNames = {
            'United States': 'USA',
            'United Kingdom': 'UK',
            Germany: 'Germany',
            Canada: 'Canada',
            Australia: 'Australia',
            France: 'France',
            Netherlands: 'Netherlands',
            Singapore: 'Singapore',
            India: 'India',
            Japan: 'Japan'
        };
        const barsMarkup = salaryData.map((country)=>{
            const widthPercent = maxSalary > 0 ? Math.round(country.avgSalary / maxSalary * 100) : 0;
            const shortName = shortNames[country.name] || country.name;
            return `
          <div class="salary-bar">
            <div class="salary-bar__label">
              <span class="salary-bar__flag">${country.flag}</span>
              <span class="salary-bar__country">${shortName}</span>
            </div>
            <div class="salary-bar__track">
              <div class="salary-bar__fill" style="--width: ${widthPercent}%"></div>
            </div>
            <span class="salary-bar__value">$${country.avgSalary.toLocaleString()}</span>
          </div>
        `;
        }).join('');
        this._salaryChartEl.innerHTML = `<div class="salary-bars">${barsMarkup}</div>`;
        // Animate bars
        requestAnimationFrame(()=>{
            this._salaryChartEl.querySelectorAll('.salary-bar__fill').forEach((bar)=>{
                bar.style.width = bar.style.getPropertyValue('--width');
            });
        });
    }
    // =============================================
    // Job Type Distribution (Donut Chart)
    // =============================================
    _renderTypeChart(typeData, totalJobs) {
        if (!this._typeChartEl || !typeData) {
            if (this._typeChartEl) this._typeChartEl.innerHTML = '<div class="chart-empty">No type data available</div>';
            return;
        }
        const circumference = 2 * Math.PI * 40; // r=40
        const remoteLen = typeData.remote / 100 * circumference;
        const hybridLen = typeData.hybrid / 100 * circumference;
        const onsiteLen = typeData.onsite / 100 * circumference;
        this._typeChartEl.innerHTML = `
      <div class="donut-chart">
        <div class="donut-chart__visual">
          <svg viewBox="0 0 100 100" class="donut-chart__svg">
            <circle
              class="donut-chart__ring donut-chart__ring--remote"
              cx="50" cy="50" r="40"
              stroke-dasharray="${remoteLen} ${circumference}"
              stroke-dashoffset="0"
            />
            <circle
              class="donut-chart__ring donut-chart__ring--hybrid"
              cx="50" cy="50" r="40"
              stroke-dasharray="${hybridLen} ${circumference}"
              stroke-dashoffset="${-remoteLen}"
            />
            <circle
              class="donut-chart__ring donut-chart__ring--onsite"
              cx="50" cy="50" r="40"
              stroke-dasharray="${onsiteLen} ${circumference}"
              stroke-dashoffset="${-(remoteLen + hybridLen)}"
            />
          </svg>
          <div class="donut-chart__center">
            <span class="donut-chart__total">${this._formatNumber(totalJobs)}</span>
            <span class="donut-chart__label">Jobs</span>
          </div>
        </div>
        <div class="donut-chart__legend">
          <div class="donut-chart__legend-item">
            <span class="donut-chart__legend-color donut-chart__legend-color--remote"></span>
            <span class="donut-chart__legend-label">Remote</span>
            <span class="donut-chart__legend-value">${typeData.remote}%</span>
          </div>
          <div class="donut-chart__legend-item">
            <span class="donut-chart__legend-color donut-chart__legend-color--hybrid"></span>
            <span class="donut-chart__legend-label">Hybrid</span>
            <span class="donut-chart__legend-value">${typeData.hybrid}%</span>
          </div>
          <div class="donut-chart__legend-item">
            <span class="donut-chart__legend-color donut-chart__legend-color--onsite"></span>
            <span class="donut-chart__legend-label">On-site</span>
            <span class="donut-chart__legend-value">${typeData.onsite}%</span>
          </div>
        </div>
      </div>
    `;
    }
    // =============================================
    // Top Skills Chart
    // =============================================
    _renderSkillsChart(skillsData) {
        if (!this._skillsChartEl || !skillsData || skillsData.length === 0) {
            if (this._skillsChartEl) this._skillsChartEl.innerHTML = '<div class="chart-empty">No skills data available</div>';
            return;
        }
        const barsMarkup = skillsData.map((skill)=>{
            const percent = Math.min(skill.percent, 100);
            return `
          <div class="skill-item">
            <span class="skill-item__name">${skill.name}</span>
            <div class="skill-item__bar">
              <div class="skill-item__fill" style="--width: ${percent}%"></div>
            </div>
            <span class="skill-item__percent">${percent}%</span>
          </div>
        `;
        }).join('');
        this._skillsChartEl.innerHTML = `<div class="skills-list">${barsMarkup}</div>`;
        // Animate bars
        requestAnimationFrame(()=>{
            this._skillsChartEl.querySelectorAll('.skill-item__fill').forEach((bar)=>{
                bar.style.width = bar.style.getPropertyValue('--width');
            });
        });
    }
    // =============================================
    // Salary Converter Handler
    // =============================================
    addHandlerSalaryConverter() {
        const convertHandler = async ()=>{
            const amount = parseFloat(this._salaryInputEl?.value);
            const fromCurrency = this._fromCurrencyEl?.value || 'USD';
            const targetCurrency = this._toCurrencyEl?.value || 'NPR';
            if (!amount || isNaN(amount)) {
                if (this._convertedSalaryEl) this._convertedSalaryEl.textContent = 'Enter a salary amount';
                if (this._resultCurrencyEl) this._resultCurrencyEl.textContent = '';
                return;
            }
            const currencyNames = {
                USD: 'US Dollar',
                EUR: 'Euro',
                GBP: 'British Pound',
                NPR: 'Nepali Rupee',
                CHF: 'Swiss Franc',
                INR: 'Indian Rupee',
                AUD: 'Australian Dollar',
                CAD: 'Canadian Dollar',
                JPY: 'Japanese Yen',
                SGD: 'Singapore Dollar'
            };
            try {
                if (this._convertedSalaryEl) this._convertedSalaryEl.textContent = 'Converting...';
                const converted = await (0, $bd02c871d9c5ba8e$export$dca80e37bfad9c5a)(amount, fromCurrency, targetCurrency);
                if (this._convertedSalaryEl) {
                    const formatted = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: targetCurrency,
                        maximumFractionDigits: 0
                    }).format(converted);
                    this._convertedSalaryEl.textContent = formatted;
                }
                if (this._resultCurrencyEl) {
                    const name = currencyNames[targetCurrency] || targetCurrency;
                    this._resultCurrencyEl.textContent = `${targetCurrency} (${name})`;
                }
            } catch (err) {
                console.error('Conversion failed:', err);
                if (this._convertedSalaryEl) this._convertedSalaryEl.textContent = 'Conversion failed';
            }
        };
        // Debounced input handler
        let debounceTimer;
        this._salaryInputEl?.addEventListener('input', ()=>{
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(convertHandler, 500);
        });
        this._fromCurrencyEl?.addEventListener('change', convertHandler);
        this._toCurrencyEl?.addEventListener('change', convertHandler);
    }
}
var $63032305c62fef5e$export$2e2bcd8739ae039 = new $63032305c62fef5e$var$AnalyticsView();


// Main controller for job search - just handles data
const $f50bd1f2915ed0f2$var$controlJobResults = async function(query, page = 1, filters = {}) {
    try {
        (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)('Controller: Starting job search', {
            query: query,
            page: page,
            filters: filters
        });
        (0, $67c1b3a106a8708b$export$2e2bcd8739ae039).renderSpinner();
        (0, $67c1b3a106a8708b$export$2e2bcd8739ae039).clearGrid();
        // Fetch jobs using the API
        await $0f1d4402dffacf5b$export$a9242d464ae29af9(query, page, filters);
        (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)('Controller: Jobs fetched, rendering results');
        // Render the results and pagination
        (0, $67c1b3a106a8708b$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
        (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
        // Trigger analytics fetch in background (only on first page/initial search)
        if (page === 1) $f50bd1f2915ed0f2$var$controlAnalytics(query);
    } catch (err) {
        (0, $bd02c871d9c5ba8e$export$58da9968c3170cb1)(err);
        (0, $67c1b3a106a8708b$export$2e2bcd8739ae039).renderError(err);
    }
};
// Controller for applying filters (debounced to avoid rapid re-fetches)
let $f50bd1f2915ed0f2$var$_filterTimeout = null;
const $f50bd1f2915ed0f2$var$controlFilters = async function(newFilters) {
    (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\uD83D\uDD27 Controller: Applying filters", newFilters);
    // Debounce rapid filter changes (300ms)
    if ($f50bd1f2915ed0f2$var$_filterTimeout) clearTimeout($f50bd1f2915ed0f2$var$_filterTimeout);
    $f50bd1f2915ed0f2$var$_filterTimeout = setTimeout(async ()=>{
        const { query: query } = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search;
        // Reset to page 1 when applying new filters
        await $f50bd1f2915ed0f2$var$controlJobResults(query, 1, newFilters);
    }, 300);
};
const $f50bd1f2915ed0f2$var$controlJobClick = function(jobId, type = 'result') {
    if (type === 'result') {
        const job = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.find((result)=>result.id === jobId);
        (0, $a2f79806c4e7b655$export$2e2bcd8739ae039).render(job);
    }
    if (type === 'bookmark') {
        const job = $0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks.find((bookmark)=>bookmark.id === jobId);
        (0, $a2f79806c4e7b655$export$2e2bcd8739ae039).render(job);
    }
};
const $f50bd1f2915ed0f2$var$controlServerHealth = async function() {
    (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\uD83D\uDD0D Checking proxy server health...");
    const health = await $0f1d4402dffacf5b$export$533f00fdb8b73d07();
    (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\u2705 Proxy server is running!");
    return health;
};
const $f50bd1f2915ed0f2$var$controlCurrencyDisplay = function(convertTo) {
    $0f1d4402dffacf5b$export$381e6799299f1fad(convertTo);
    (0, $67c1b3a106a8708b$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search, $0f1d4402dffacf5b$export$ca000e230c0caa3e.currency);
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e);
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks, $0f1d4402dffacf5b$export$ca000e230c0caa3e.currency);
};
const $f50bd1f2915ed0f2$var$controlBookmarks = function(jobId) {
    const job = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search.results.find((result)=>result.id === jobId);
    if (!$0f1d4402dffacf5b$export$51484a9f0c0ed0a3(jobId)) $0f1d4402dffacf5b$export$72009cc673d27d80(job);
    else $0f1d4402dffacf5b$export$2db69b245b3902c8(jobId);
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
};
const $f50bd1f2915ed0f2$var$controlBookmarkRemove = function(jobId) {
    $f50bd1f2915ed0f2$var$controlBookmarks(jobId);
    (0, $67c1b3a106a8708b$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
};
const $f50bd1f2915ed0f2$var$controlBookmarkModal = function(job) {
    if (!$0f1d4402dffacf5b$export$51484a9f0c0ed0a3(job.id)) $0f1d4402dffacf5b$export$72009cc673d27d80(job);
    else $0f1d4402dffacf5b$export$2db69b245b3902c8(job.id);
    // Update all views
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
    (0, $67c1b3a106a8708b$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.search);
};
// Analytics controller - fetches and renders analytics data
const $f50bd1f2915ed0f2$var$controlAnalytics = async function(query) {
    try {
        if (!query) return;
        (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\uD83D\uDCCA Controller: Fetching analytics for", query);
        (0, $63032305c62fef5e$export$2e2bcd8739ae039).renderSpinner();
        const analyticsData = await $0f1d4402dffacf5b$export$b0297573c90085aa(query);
        (0, $63032305c62fef5e$export$2e2bcd8739ae039).render(analyticsData);
        (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\u2705 Analytics rendered successfully");
    } catch (err) {
        (0, $bd02c871d9c5ba8e$export$58da9968c3170cb1)("\u274C Analytics failed:", err);
        (0, $63032305c62fef5e$export$2e2bcd8739ae039).renderError('Failed to load analytics. Please try again.');
    }
};
const $f50bd1f2915ed0f2$var$init = function() {
    (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\uD83D\uDE80 JobLens Application Starting...");
    $f50bd1f2915ed0f2$var$controlServerHealth();
    (0, $5c69f0cf8a0ecb5c$export$2e2bcd8739ae039).addHandlerCurrency($f50bd1f2915ed0f2$var$controlCurrencyDisplay);
    (0, $5c69f0cf8a0ecb5c$export$2e2bcd8739ae039).addHandlerNavBtn();
    (0, $67c1b3a106a8708b$export$2e2bcd8739ae039).addHandlerRetry($f50bd1f2915ed0f2$var$controlJobResults);
    (0, $67c1b3a106a8708b$export$2e2bcd8739ae039).addHandlerJobClick($f50bd1f2915ed0f2$var$controlJobClick);
    (0, $67c1b3a106a8708b$export$2e2bcd8739ae039).addHandlerBookmark($f50bd1f2915ed0f2$var$controlBookmarks);
    (0, $cfa940594ee109f7$export$2e2bcd8739ae039).addHandlerClick((page)=>{
        const { query: query, filters: filters } = $0f1d4402dffacf5b$export$ca000e230c0caa3e.search;
        $f50bd1f2915ed0f2$var$controlJobResults(query, page, filters);
    });
    (0, $4a4a6495d2c823bb$export$2e2bcd8739ae039).showSuggestions();
    (0, $4a4a6495d2c823bb$export$2e2bcd8739ae039).addHandlerSearch($f50bd1f2915ed0f2$var$controlJobResults);
    (0, $4a4a6495d2c823bb$export$2e2bcd8739ae039).addHandlerFilters($f50bd1f2915ed0f2$var$controlFilters);
    (0, $4a4a6495d2c823bb$export$2e2bcd8739ae039).addHandlerSuggestions($f50bd1f2915ed0f2$var$controlJobResults);
    (0, $4a4a6495d2c823bb$export$2e2bcd8739ae039).focusSearch();
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).render($0f1d4402dffacf5b$export$ca000e230c0caa3e.bookmarks);
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).addHandlerRemoveBookmark($f50bd1f2915ed0f2$var$controlBookmarkRemove);
    (0, $5d1bb7e064b2cbd1$export$2e2bcd8739ae039).addHandlerViewBookmark($f50bd1f2915ed0f2$var$controlJobClick);
    (0, $a2f79806c4e7b655$export$2e2bcd8739ae039).addHandlerBookmarkModal($f50bd1f2915ed0f2$var$controlBookmarkModal);
    // Analytics
    (0, $63032305c62fef5e$export$2e2bcd8739ae039).renderEmpty();
    (0, $63032305c62fef5e$export$2e2bcd8739ae039).addHandlerSalaryConverter();
    (0, $bd02c871d9c5ba8e$export$bef1f36f5486a6a3)("\u2705 JobLens Application Ready!");
};
// Start the application
$f50bd1f2915ed0f2$var$init();


//# sourceMappingURL=path0.b8a93877.js.map
